import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { CheckOutlined } from "@ant-design/icons";
import CATEGORIES from "utils/categories";
import { NavLink } from "react-router-dom";
import { collectUserInput, isPopulated } from "utils/helpers";
import { getRecommendations } from "actions/recommendationsActions";
import "styles/ProgressIndicator.scss";
class ProgressIndicator extends Component {
  sendUserInput = () => {
    const userInput = collectUserInput();
    this.props.dispatch(getRecommendations(userInput));
  };

  renderSummaryCircle = () => {
    const { pathname } = this.props.location;
    const highlightSummaryCircle =
      pathname.match(/^\/summary/) !== null ? true : false;
    const enableSummary = CATEGORIES.map((cat) => isPopulated(cat)).some(
      (catPopulated) => catPopulated === true
    );
    const number = CATEGORIES.length + 1;

    if (enableSummary) {
      return (
        <NavLink
          to="/summary"
          onClick={this.sendUserInput}
          className={
            "progress-indicator-circle circle-view-subjects " +
            (highlightSummaryCircle && "active")
          }
        >
          {number}
        </NavLink>
      );
    } else {
      return (
        <div
          className={
            "progress-indicator-circle " +
            (highlightSummaryCircle ? "active" : "circle-disabled")
          }
        >
          {number}
        </div>
      );
    }
  };

  currentIndex = () => {
    const { pathname } = this.props.location;
    const catNavlink = pathname.split("/").filter((i) => i)[0];
    let currentIndex = CATEGORIES.length;
    CATEGORIES.forEach((cat, i) => {
      if (catNavlink === cat.navlink) {
        currentIndex = i;
      }
    });
    return currentIndex;
  };

  renderCategoryCircle = (cat, i) => {
    const populated = isPopulated(cat);
    const currentIndex = this.currentIndex();

    if (currentIndex > i) {
      // render a clickable button
      return (
        <NavLink
          key={i}
          to={`/${cat.navlink}`}
          className={
            "progress-indicator-circle" + (populated ? " complete" : "")
          }
        >
          {populated ? <CheckOutlined /> : i + 1}
        </NavLink>
      );
    } else {
      //
    }

    if (currentIndex < i && !populated) {
      return (
        <div key={i} className="progress-indicator-circle circle-disabled">
          {populated ? <CheckOutlined /> : i + 1}
        </div>
      );
    }

    return (
      <NavLink
        key={i}
        to={`/${cat.navlink}`}
        // onClick={event => this.handleClick(event, populated, i)}
        className={"progress-indicator-circle" + (populated ? " complete" : "")}
      >
        {populated ? <CheckOutlined /> : i + 1}
      </NavLink>
    );
  };

  render() {
    return (
      <div className="tablet-and-mobile">
        <div className="progress-indicator-container">
          <div className="progress-indicator">
            {CATEGORIES.map((cat, i) => this.renderCategoryCircle(cat, i))}
            {this.renderSummaryCircle()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { userInterests } = store.interestsReducer;
  const { userSkills } = store.skillsReducer;
  const { userPersonality } = store.personalityReducer;
  const { userCareers } = store.careersReducer;
  const { userCourses } = store.coursesReducer;

  return {
    // other user input
    userInterests: userInterests,
    userSkills: userSkills,
    userPersonality: userPersonality,
    userCareers: userCareers,
    userCourses: userCourses,
  };
};

export default withRouter(connect(mapStateToProps)(ProgressIndicator));
